
import { parse } from "qs";

const queryParams = parse(location.search, { ignoreQueryPrefix: true });
let restricted: string = (queryParams.restricted ?? queryParams.Restricted) as string;

export const isRestricted: boolean = restricted === 'true';